const GENESIS = '0'.repeat(64);
async function sha256Hex(text) {
    const buf = new TextEncoder().encode(text);
    const digest = await crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
/** Reproduce backend's canonical JSON (backend/src/audit/service.rs).
 *  Order of keys must match — serde_json defaults to insertion order for
 *  json!({...}) macro. Backend order: actor_id, action, resource_type,
 *  resource_id, payload, ts_iso.
 */
function canonicalize(row) {
    return JSON.stringify({
        actor_id: row.actor_id ?? null,
        action: row.action,
        resource_type: row.resource_type ?? null,
        resource_id: row.resource_id ?? null,
        payload: row.payload ?? null,
        ts_iso: row.ts,
    });
}
/** Verify a slice of audit rows in ascending seq order.
 *  Rows must be sorted by seq ASC and start from seq=1 (or from a row
 *  whose prev_hash matches the immediately preceding seq's hash — caller
 *  responsible for pagination continuity if not starting at seq=1).
 */
export async function verifyChain(rows) {
    if (rows.length === 0)
        return { ok: true, totalChecked: 0 };
    const sorted = [...rows].sort((a, b) => a.seq - b.seq);
    // If the first row is not seq=1, we can only check chain-consistency
    // (each row's prev_hash matches previous row's hash), not root-anchor.
    const firstIsGenesis = sorted[0].seq === 1;
    let expectedPrev = firstIsGenesis ? GENESIS : sorted[0].prev_hash;
    for (const row of sorted) {
        if (row.prev_hash !== expectedPrev) {
            return {
                ok: false,
                totalChecked: sorted.indexOf(row),
                firstBadSeq: row.seq,
                reason: `Rantai putus di seq=${row.seq}: prev_hash ${row.prev_hash.slice(0, 12)}… tidak cocok hash sebelumnya ${expectedPrev.slice(0, 12)}…`,
            };
        }
        const canonical = canonicalize(row);
        const computed = await sha256Hex(row.prev_hash + canonical);
        if (computed !== row.hash) {
            return {
                ok: false,
                totalChecked: sorted.indexOf(row),
                firstBadSeq: row.seq,
                reason: `Hash tidak cocok di seq=${row.seq}: perhitungan lokal ${computed.slice(0, 12)}… ≠ hash tersimpan ${row.hash.slice(0, 12)}…`,
            };
        }
        expectedPrev = row.hash;
    }
    return { ok: true, totalChecked: sorted.length };
}
